import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from "react-router-dom";
import './index.css';
import App from './App';
import strings from "./language/config";
import * as serviceWorker from './serviceWorker';
import moment from 'moment';
import 'moment/locale/tr';

console.disableYellowBox = true;
global.strings = strings;

// Set Turkish locale globally for moment.js with Monday as first day of week
if (localStorage.getItem('_lang') === 'tr') {
    moment.locale('tr');
    moment.updateLocale('tr', {
        week: {
            dow: 1, // Monday is the first day of the week
            doy: 4  // The week that contains Jan 4th is the first week of the year
        }
    });
}

ReactDOM.render(<Router>
        <App/>
    </Router>, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
